import React from 'react';
import { useEffect, useRef } from 'react';

function SkipToMainContent() {

  return (
    <div className="skip-links">
      <a 
        href="#main-content"
        tabIndex="0" 
        className="skip-link"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const mainContent = document.querySelector('#main-content nav+section') || document.querySelector('#main-content');
            if (mainContent) {
              mainContent.tabIndex = 0;
              mainContent.focus();
            }
          }
        }}
      >
        Skip to main content
      </a>
    </div>
  );
}

export default SkipToMainContent;